import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";


export const createNeighborhoodNewsComment = createAsyncThunk("createNeighborhoodNewsComment", async ({ id, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/add-comment/${id}/`, data)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const getNeighborhoodNewsComment = createAsyncThunk("getNeighborhoodNewsComment", async ({ id, page }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/comments/${id}?page=${page}`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const updateNeighborhoodNewsComment = createAsyncThunk("updateNeighborhoodNewsComment", async ({ commentId, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.patch(`/neighbor_news/update_comment/${commentId}/`, data)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }

        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const deleteNeighborhoodNewsComment = createAsyncThunk("deleteNeighborhoodNewsComment", async ({ commentId }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.delete(`/neighbor_news/delete_comment/${commentId}/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const likeDislikeNeighborhoodNewsComment = createAsyncThunk("likeDislikeNeighborhoodNewsComment", async ({ commentId }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/like_comment/${commentId}/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const createNeighborhoodNewsCommentReply = createAsyncThunk("createNeighborhoodNewsCommentReply", async ({ commentId, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/comments/${commentId}/reply/`, data)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            return rejectWithValue("No response from server");
        }
        else {
            return rejectWithValue(error.message);
        }
    }
});

export const getNeighborhoodNewsCommentReplies = createAsyncThunk("getNeighborhoodNewsCommentReplies", async (comment_id, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/comments/${comment_id}/replies/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const updateNeighborhoodNewsCommentReply = createAsyncThunk("updateNeighborhoodNewsCommentReply", async ({ replyId, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.patch(`/neighbor_news/reply/${replyId}/update/`, data)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const deleteNeighborhoodNewsCommentReply = createAsyncThunk(
    "deleteNeighborhoodNewsCommentReply",
    async ({ replyId }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`/neighbor_news/reply/${replyId}/delete/`);
            const result = response.data;
            return result;
        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                return rejectWithValue(error.response.data);
            } else if (error.request) {
                // The request was made but no response was received
                return rejectWithValue("No response from server");
            } else {
                // Something happened in setting up the request that triggered an Error
                return rejectWithValue(error.message);
            }
        }
    }
);

export const likeDislikeNeighborhoodNewsCommentReply = createAsyncThunk("likeDislikeNeighborhoodNewsCommentReply", async ({ replyId }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/reply/${replyId}/like/`)
        const result = response.data;
        return result
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return rejectWithValue(error.response.data);
        }
        else if (error.request) {
            // The request was made but no response was received
            return rejectWithValue("No response from server");
        }
        else {
            // Something happened in setting up the request that triggered an Error
            return rejectWithValue(error.message);
        }
    }
});

export const NeighborhoodNewsCommentSlice = createSlice({
    name: "NeighborhoodNews",
    initialState: {
        neighborhoodNewsComments: [],
        neighborHoodNewsCommentReplies: [],
        loading: false,
        replyLoading: false,
        error: null,
    },
    extraReducers: (builder) => {
        // createNeighborhoodNewsComment
        builder.addCase(createNeighborhoodNewsComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createNeighborhoodNewsComment.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(createNeighborhoodNewsComment.rejected, (state, action) => {
            state.loading = false;
        });
        // get NeighborhoodNews Comment
        builder.addCase(getNeighborhoodNewsComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getNeighborhoodNewsComment.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodNewsComments = action.payload;
        });
        builder.addCase(getNeighborhoodNewsComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // get update Comment
        builder.addCase(updateNeighborhoodNewsComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateNeighborhoodNewsComment.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(updateNeighborhoodNewsComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // create comment reply Comment
        builder.addCase(createNeighborhoodNewsCommentReply.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(createNeighborhoodNewsCommentReply.fulfilled, (state, action) => {
            state.replyLoading = false;
        });
        builder.addCase(createNeighborhoodNewsCommentReply.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });
        // get update Comment
        builder.addCase(getNeighborhoodNewsCommentReplies.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(getNeighborhoodNewsCommentReplies.fulfilled, (state, action) => {
            state.replyLoading = false;
            state.neighborHoodNewsCommentReplies = action.payload;
        });
        builder.addCase(getNeighborhoodNewsCommentReplies.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });

    },
});

export default NeighborhoodNewsCommentSlice.reducer;